<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'SupportCategoryCenter',
            to: {
              name: 'SupportCategoryCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'SupportCategoryEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改項目</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 修改項目 -->
    <SupportCategoryCreateEdit></SupportCategoryCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportCategoryCreateEdit from '@/views/G-2__SupportCategory/c/SupportCategoryCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    SupportCategoryCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('supportcategory', ['supportcategory']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getSupportCategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('supportcategory', {
      getSupportCategory: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'SupportCategoryCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.supportcategory.title) {
            this.errors.push('標題 required.');
          } else if (!this.supportcategory.bu_id) {
            this.errors.push('BU required.');
          } else if (!this.supportcategory.type) {
            this.errors.push('類型 required.');
          } /* else if (!this.supportcategory.slug) {
            this.errors.push('Slug required.');
          } */
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.supportcategory).then(() => {
            this.$router.push({ name: 'SupportCategoryCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>
<style></style>
